/**
 * Pont entre le HUD et la bannière de l'ennemi (v0.49.0, A98).
 *
 * Les effets de l'ennemi s'affichent dans sa bannière (`game3d/overlay.ts`),
 * sous son nom. La vue de combat ne passe pas la partie à la couche DOM : le
 * HUD (`ui/screens/combatHud.ts`), lui, la tient. Il **publie** ici une
 * fonction qui rend les libellés des effets de l'ennemi courant ; la bannière
 * la lit quand son libellé change. Rien ici ne dépend du cœur ni du DOM.
 */

/** Liste vide partagée : aucune allocation quand l'ennemi n'a pas d'effet. */
export const NO_EFFECT_LINES: readonly string[] = Object.freeze([]);

type Provider = () => readonly string[];

let provider: Provider | null = null;

/** Branche (ou débranche, avec `null`) la source des libellés d'effets. */
export function setEnemyEffectsProvider(fn: Provider | null): void {
  provider = fn;
}

/**
 * Libellés des effets de l'ennemi courant, un par ligne ; vide sans source, sans
 * ennemi ou sans effet. Ne lève jamais : la bannière ne doit pas casser.
 */
export function currentEnemyEffects(): readonly string[] {
  if (!provider) return NO_EFFECT_LINES;
  try {
    return provider() ?? NO_EFFECT_LINES;
  } catch {
    return NO_EFFECT_LINES;
  }
}
